module.exports = __webpack_public_path__ + "img/poster4.jpg.d377e43b.webp";